import React from 'react';
import { useRouteInfo } from '../../../services/routing/useRouteInfo';
import { SearchInput } from '../../shared/inputs/search';

import styles from './searchBar.module.css';

export const SearchBar = () => {

    const routeInfo = useRouteInfo();

    return <div className={styles.SearchBar}>
        {/* {
            (routeInfo.showQuickSearch ?? false) ?
            <SearchInput
                isLight={true}
                onSearch={() => {}}
            />
            : ''
        } */}
    </div>
}